import React, { Component } from "react";
import style from "./list.module.sass";
import { Table, Icon, Spin } from "antd";
import { Button, Modal } from "../../../../helpers/commonUi";
import Service from "./Service";
import { Http } from "../../../../helpers/axois";
import moment from 'moment'
import { ReactComponent as TableEdit } from '../../../../assets/svg/editIcon.svg'
import { ReactComponent as Delete } from '../../../../assets/svg/delete.svg'
import serviceImg from "../../../../assets/images/create_service.svg";
import { ReactComponent as Acl } from '../../../../assets/svg/acl.svg'

import NoData from "../../NoData";
import { AppState } from "../../../../stateManager/store";
import { connect } from "react-redux";
import { pushToast } from "../../../../stateManager/store/toast/actions";
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'
import { selectedServices } from "../../../../stateManager/store/solo/action";
import { setStepIndex } from "../../../../stateManager/store/onboarding/action";
import AclServiceDrawer from "../forms/create/AclServiceDrawer";
import { getOnboarding } from "../../../../helpers/onboardingHelper";
import SearchBar, { highlightMatch } from "../../../../helpers/SearchBar";

interface State {
  visible: boolean;
  editInitialData?: {};
  editSoloIntitialData?: {};
  serviceList?: any[];
  soloServiceList?: any[];
  editable: boolean;
  editvisible?: boolean;
  loading?: boolean;
  deleteVisible: boolean;
  deleteData: any;
  editType: any;
  aclDrawerVisible?:boolean;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}

interface Props {
  match?: any;
  app?: any;
  history?: any;
  deleteService: (data: any) => void;
  appVersion?: { currentVersion: boolean, versionId: string }
  pushToast: (data: any) => void;
  selectedServices: (data: any) => void;
  orgPermissions: any;
  appPermissions: any;
  currentBranch?: any;
  guideVisible?: boolean;
  onboardingInfo?: any;
  userName?: any;
  setStepIndex?: any;
}

class ServiceList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      editInitialData: {},
      editSoloIntitialData: {},
      editType: "",
      editable: false,
      serviceList: [],
      editvisible: false,
      loading: false,
      deleteVisible: false,
      deleteData: {},
      aclDrawerVisible: false,
      filteredData: [],
      searchValue: "",
      searchRef: React.createRef(),
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.versionUpdate(this.props);
  }

  componentWillReceiveProps(props: Props) {
    if (props.appVersion !== this.props.appVersion) {
      this.versionUpdate(props);
    }
  }

  versionUpdate(props: Props) {
    const version = props.appVersion;
    if (version) {
      this.getService(props);
      // this.getSoloService(props);
    }
  }

  getService(props: Props) {
    const version = props.appVersion && props.appVersion.versionId;
    const appId = this.props.match.params.appId;
    const currentBranchId = this.props.currentBranch && this.props.currentBranch[appId] && this.props.currentBranch[appId].branchId
    this.state.searchRef.current?.clearSearch()
    Http.get(`/apps/${appId}/services?versionId=${version}&branchId=${currentBranchId}`).subscribe((serviceRes: any) => {
      this.setState({
        serviceList: serviceRes,
        filteredData: serviceRes,
        loading: false,
      });
    }, (err) => {
      if (err !== 'Forbidden') {
        this.setState({
          serviceList: [],
          filteredData: [],
          loading: false
        })
        this.props.pushToast(
          { type: 'error', message: (err && err.message) ? err.message : "Services Getting failed" }
        )
      }
    });
  }

  deleteService(serviceId: string) {
    this.setState({
      loading: true
    })
    const appId = this.props.match.params.appId
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    Http.delete(`/services/${serviceId}?appId=${appId}&versionId=${versionId}`).subscribe((res) => {
      this.props.pushToast(
        { type: 'success', message: 'Service deleted successfully' }
      )
      this.getService(this.props);
      this.setState({
        loading: false,
        deleteVisible: false,
        searchValue: "",
        filteredData: this?.state?.serviceList || []
      })
    }, (err) => {
      this.setState({
        loading: false,
        deleteVisible: false,
        searchValue: "",
        filteredData: this?.state?.serviceList || []
      })
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'Service deletion failed' }
      )
    })
  }

  getServiceAfterReScan = async () => {
    await this.getService(this.props)
  }


  render() {
    const currentVersion = this.props.appVersion && this.props.appVersion.currentVersion
    const canEditService = currentVersion && (this.props.orgPermissions.includes('service.Edit') || this.props.appPermissions.includes('service.Edit'))
    const canCreateService = currentVersion && (this.props.orgPermissions.includes('service.Create') || this.props.appPermissions.includes('service.Create'))
    const canDeleteService = currentVersion && (this.props.orgPermissions.includes('service.Delete') || this.props.appPermissions.includes('service.Delete'))
    const canViewService = this.props.orgPermissions.includes('service.View') || this.props.appPermissions.includes('service.View')

    const columns: any = [
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Name(Identifier)",
        dataIndex: "name",
        key: "name",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "App Name",
        dataIndex: "appName",
        key: "appName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Updated At",
        dataIndex: "updatedAt",
        key: "updatedAt",
        render: (text: string) => {
          let formattedValue: any  = text ?  moment(text).local().format("DD-MM-YYYY hh:mm a") : "-"
          formattedValue = highlightMatch(formattedValue, this.state.searchValue)
          return formattedValue
        }
      }
    ];

    if (currentVersion) {
      columns.push(
        {
          title: "Action",
          key: "action",
          render: (text: any, record: any) => (
            <div className="action action_grp">
              <span  data-test-id="action_edit"
                className="action-icon acl-icon"
                title="Policy"
                style={{margin:0}}
                onClick={e => {
                  if (this.props.guideVisible) {
                    return;
                  }
                  e.stopPropagation();
                  if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                    this.props.pushToast({
                      type: 'error',
                      message: 'Cannot modify a previous app version'
                    })
                    return
                  }
                  this.setState({ aclDrawerVisible: true,editInitialData: record,})
                }}
              >
                <Acl  style={{width:"15px",height:"15px"}}/>
              </span>
              <span
                data-test-id="action_edit"
                title="Edit"
                className="action-icon edit-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  if (this.props.guideVisible) {
                    return;
                  }
                  if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                    this.props.pushToast({
                      type: 'error',
                      message: 'Cannot modify a previous app version'
                    })
                    return
                  }
                  if (canEditService) {
                    this.setState({
                      editvisible: true,
                      editInitialData: record,
                      editType: "Assisted",
                      editable: true,
                    });
                  } else {
                    this.props.pushToast({
                      type: 'error',
                      message: 'You are not authorized to edit this service'
                    })
                  }
                }}
              >
                <TableEdit height='15px' width='15px' />
              </span>
              {this.state.serviceList!.length >= 1 && (
                <span
                  data-test-id="action_delete"
                  className="action-icon delete-icon"
                  title="Delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (this.props.guideVisible) {
                      return;
                    }
                    if (!(this.props.appVersion && this.props.appVersion.currentVersion)) {
                      this.props.pushToast({
                        type: 'error',
                        message: 'Cannot modify a previous app version'
                      })
                      return
                    }
                    if (canDeleteService) {
                      this.setState({
                        deleteVisible: true,
                        deleteData: record,
                        editType: "Assisted",
                      });
                    } else {
                      this.props.pushToast({
                        type: 'error',
                        message: 'You are not authorized to delete this service'
                      })
                    }
                  }}
                >
                  <Delete />
                </span>
              )}
            </div>
          ),
        }
      )
    }

    const appId = this.props.match.params.appId;
    const versionId = this.props.appVersion && this.props.appVersion.versionId;
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
    return (
      canViewService ?
        <div className='viewWrapper'>
          {
            ((!this.state.loading) && ((this.state.serviceList && this.state.serviceList.length > 0)
              || (this.state.soloServiceList && this.state.soloServiceList.length > 0)))
              ?
              <div className={"row " + style.data}>
                <div className={style.header} >
                <div className={style.first}>
                    <h4>Services</h4>
                    <h5>View, edit or create a new service</h5>
                  </div>
                  <div className={"flex " + style.first}>
                    <SearchBar
                      ref={this.state.searchRef}
                      data={this.state.serviceList}
                      columns={columns}
                      onFilter={(filteredData ) => {
                        this.setState({
                          filteredData: filteredData,
                        })
                      }}
                      onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                    />
                    {
                      canCreateService &&
                      (
                        <Button dataTestId="create_service" size="small" onClick={() => { this.setState({ visible: true }); this.props.selectedServices(null) }}>
                          CREATE SERVICE
                        </Button>
                      )
                    }
                  </div>
                </div>
                <div className={style.content}>
                  <Table
                    pagination={false}
                    // rowSelection={{ 
                    //   type : 'checkbox',
                    //   onChange: (selectedRowKeys, selectedRows) => {
                    //   }
                    // }}
                    scroll={{ y: 'calc(100vh - 240px)' }}
                    columns={columns}
                    onRow={(record: any, rowIndex: any) => {
                      return {
                        'data-test-id': 'service_table_row_' + record.key,
                        className: this.props.onboardingInfo.serviceId === record.id ? "tour_service_row_selection" : "",
                        onClick: async (event: any) => {
                          this.props.selectedServices("Assisted")
                          const tag: any = event.target;
                          if(this.props.guideVisible) {
                            const onboardingData: any = await getOnboarding(this.props.userName);
                            const stepIndex = onboardingData.stepIndex;
                            if (stepIndex !== this.props.onboardingInfo.stepIndex) {
                                this.props.setStepIndex(stepIndex);
                            } else {
                              this.props.setStepIndex(this.props.onboardingInfo.stepIndex + 1)
                            }
                          }
                          if (tag.id !== "delete") {
                            this.props.history.push(
                              "" +
                              this.props.match.url +
                              "/" +
                              record.id +
                              "/create"
                            );
                          }
                        }
                      };
                    }}
                    className={"override-table-container"}
                    dataSource={this.state.filteredData!.map((res, key) => {
                      return { ...res, key: key };
                    })}
                  />
                </div>
              </div>
              :
              (this.state.loading)
                ?
                <div className={style.loadingSpinner}>
                  <Spin indicator={antIcon} style={{ color: '#15808C' }} />
                </div>
                :
                <NoData
                  image={serviceImg}
                  header='Create Service'
                  content='Create services for your apps'
                  // buttonText='Create new version'
                  buttonCallback={() => (canCreateService) ? (this.setState({ visible: true }), this.props.selectedServices(null)) : this.props.pushToast({
                    type: 'error',
                    message: 'You are not authorized to create services'
                  })}
                />}
          <>
          </>
          {
            this.state.aclDrawerVisible ? 
            <AclServiceDrawer isSolo={false} getService={(()=>{this.getService(this.props)})}  pushToast={this.props.pushToast} aclServiceData={this.state.editInitialData} onClose={(()=>{this.setState({aclDrawerVisible: false})})}></AclServiceDrawer> : null
          }
          <ServiceModal
            visible={this.state.visible}
            editType={this.state.editType}
            getService={() => this.getService(this.props)}
            appId={appId}
            versionId={versionId}
            setvisible={(status) => this.setState({ visible: status })}
          ></ServiceModal>
          {this.state.editvisible && (
            <ServiceModal
              getService={() => this.getService(this.props)}
              visible={this.state.editable}
              editInitialData={this.state.editInitialData}
              editType={this.state.editType}
              appId={appId}
              versionId={versionId}
              setvisible={(status) => {
                this.setState({ editable: status, editInitialData: {}, editSoloIntitialData: {} });
                setTimeout(() => {
                  this.setState({ editvisible: false });
                }, 400);
              }}
              editable={this.state.editable}
            ></ServiceModal>
          )}
          <Modal
            id="deleteService"
            dataTestId="delete_service"
            unmountOnCancel={true}
            visible={this.state.deleteVisible}
            title="DELETE ASSIST SERVICE"
            onCancel={() => {
              this.setState({
                deleteVisible: false,
                deleteData: {},
              });
            }}
            deleteOptions={{
              type: "Service",
              validateString: this.state.deleteData.name
            }}
            footer={{
              enable: true,
              okText: "DELETE",
              cancelText: "CANCEL",
              onOk: () => {
                this.deleteService(this.state.deleteData.id);
              },
            }}
          />
        </div>
        :
        <div className="viewWrapper">
          <NoData
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access'
            noButton={true}
          />
        </div>
    );
  }
}

interface ServiceModelProps {
  visible: boolean;
  getService: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  versionId: any;
  editSoloIntitialData?: {};
  editInitialData?: {};
  editable?: boolean;
  editType: string;
}
let onSubmit: any;
const ServiceModal = ({ visible, getService, setvisible, editType, appId, versionId, editSoloIntitialData, editInitialData, editable }: ServiceModelProps) => {
  return (
    <Modal
      id="createEditService"
      dataTestId="create_edit_service"
      title={editInitialData ? "EDIT SERVICE" : "CREATE SERVICE"}
      visible={visible}
      onCancel={() => {
        setvisible(false);
      }}
      unmountOnCancel={true}
      footer={{
        enable: true,
        okText: editable ? "SAVE" : "CREATE",
        cancelText: "CANCEL",
        onOk: () => {
          onSubmit();
        },
      }}
    // mode='EditCreate'
    >
      <Service
        data-test-id="service"
        appId={appId}
        versionId={versionId}
        getService={getService}
        editInitialData={editInitialData}
        onSubmit={(submit) => (onSubmit = submit)}
        setvisible={(data) => setvisible(data)}
        editable={editable}
        editType={editType}
      ></Service>
    </Modal>
  );
};
const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appVersion: state.apps.appVersion[params['appId']],
    orgPermissions: state.org.orgPermissions,
    appPermissions: state.apps.selectedApp.permissions,
    currentBranch: state.apps.appBranch,
    onboardingInfo: state.onboarding.info,
    guideVisible: state.onboarding.guideVisible,
    userName: state.user.data.user.userName
  }
};

export default connect(mapStateToProps, { pushToast, selectedServices, setStepIndex })(ServiceList);
